import { ImageCircle } from '$components'
import { Text } from '$components'
import { ElementType } from 'react'

export type StatusProps = {
  photo?: string | ElementType,
  name: string
}

export function Profile({ photo, name }: StatusProps) {
  const PhotoComponent = photo && typeof photo !== 'string' ? photo : null

  return (
    <div className="flex items-center gap-2">
      {photo && typeof photo === 'string' && (
        <ImageCircle
          image={photo}
          size="sm"
        />
      )}

      {PhotoComponent && (
        <div className="text-gray-600 bg-gray-50 p-1 rounded-full">
          <PhotoComponent className="size-4" />
        </div>
      )}

      <div className="text-ellipsis overflow-hidden">
        <Text
          type="s"
          className="truncate"
        >
          { name }
        </Text>
      </div>
    </div>
  )
}
